import React, { useState, useEffect } from "react";
import { sendData, getData } from "../../../services/auth";
import { uriList } from "../../../helpers/config";
import { Button } from "reactstrap";
import { width, generateId, posicoes } from "../../../helpers";


import { confirmSwal, swalError } from "../../../helpers/swal";
import * as moment from "moment";
import { Aguarde, getCookie } from '../../../helpers/general'
import { useSelector } from "react-redux";
import UploadDocumentos from "./UploadDocumentos";
import { Pagination, InputLabelAlert, DropDownMenu } from '../../../common/layout'

let _tiposEmpresa = ["AMBOS", "EMPRESA"]
let _tiposFuncionario = ["AMBOS", "COLABORADORES"]

const Documentos = (props) => {
    const [allDocuments, setAllDocuments] = useState([]);
    const [Documentos, setDocumentos] = useState([]);
    const [modal, setModal] = useState(false);
    const [data, setData] = useState({ id: 0, descricao: "", file: null });
    const [excluindo, setExcluindo] = useState(false)
    const _login = useSelector((state) => state.login);
    const [pessoaid, setPessoaID] = useState(props.empresa ? _login.empresaid : null)
    const [tipos, setTipos] = useState([])
    const [carregando, setCarregando] = useState(true)
    const [actualPage, setActualPage] = useState(0)
    const [editar, setEditar] = useState(null)
    const [pesquisa, setPesquisa] = useState("")
    const [qtdLinesPage, setQtdLinesPage] = useState(getCookie({ label: "qtdLinesPage" }) || 10)
    const [posicao, setPosicao] = useState(props.posicao)

    let agrupamento, grupo

    async function _getData(_posicao) {
        setEditar(null)
        setCarregando(true)
        await sendData({ uri: uriList("documentos"), content: { pessoaid: null } })
            .then((_res) => {
                const res = _res.data || _res
                console.log("Documentos._getData: ", res);

                if (res) {
                    let _data = res
                    if (props.empresa) _data = _data.filter(x => x.EMPRESA)
                    else _data = _data.filter(x => x.COLABORADOR == 'SIM' && x.EMPRESA <= 0)
                    setAllDocuments(_data)

                    if (posicao || pesquisa)
                        filtrarRegistros()
                    else
                        setDocumentos(_data)
                }
            })
            .catch((e) => {
                console.log(e);
                // alert("Erro ao obter Documentos.\n" + e.message);
            });

        await getData({ uri: uriList("tiposDocumento") })
            .then((res) => {
                if (res.status && parseInt(res.status) > 200) throw new Error();
                setTipos(res)
                // console.log("Documentos.index._getData(Tipos de Documento): ", res);
                if (res && res.length)
                    setData({ ...data, tipo_documentoid: res[0].ID })
            })
            .catch((e) => {
                console.log(e);
                alert("Erro ao obter Tipos de Documento.\n" + e.message);
            });
        setCarregando(false)
    }

    useEffect(() => {
        _getData(props.posicao);
    }, []);

    useEffect(() => {
        filtrarRegistros()
    }, [posicao, pesquisa])

    function handleCopiar(text) {
        navigator.clipboard.writeText(text)
    }

    async function closeModal() {
        handleLimparFiltros()
        setModal(false)
        await _getData();
        setEditar(null)
    }

    async function handleDelete(element) {
        function callback(p) {
            console.log("Documentos.handleDelete: ", element)
            if (p) {
                setExcluindo(true)
                sendData({ uri: uriList("documentosDel"), content: { ...element, } })
                    .then((res) => {
                        console.log("Documentos - Deletado: ", res);
                        setExcluindo(false)
                        if (res.status && parseInt(res.status) > 200) {
                            swalError({
                                title: `Erro ao excluir registro! \n${res.data || res.message || res.erro}`,
                            });
                            return
                        }

                        _getData();
                    })
                    .catch(error => {
                        console.log(error);
                        setExcluindo(false)
                        swalError({
                            title: `Erro ao excluir registro! \n${error.message}`,
                        });
                    })
            }
        }

        confirmSwal({ callback, title: "Confirma a execução do processo?" });
    }

    function handlePage(e) {
        setActualPage(e.currentTarget.value);
    }

    function handleEdit(e) {
        setEditar(e)
        setModal(true);
    }

    function filtrarRegistros() {
        if (pesquisa || posicao) {
            let _pesquisa = pesquisa.toLowerCase()
            let _docs = allDocuments.filter(e =>
                (!pesquisa || e.PESSOA?.toLowerCase().indexOf(_pesquisa) >= 0 || e.TIPO_DOCUMENTO?.toLowerCase().indexOf(_pesquisa) >= 0 ||
                    e.CATEGORIA?.toLowerCase().indexOf(_pesquisa) >= 0 || e.URL_ARQUIVO?.toLowerCase().indexOf(_pesquisa) >= 0) &&
                (!posicao || e.POSICAO == posicao || (posicao == 'VALIDO' && ['VENCENDO', 'ATIVO'].indexOf(e.POSICAO) >= 0))
            )
            setDocumentos(_docs)
            setActualPage(0);
        }
        else
            setDocumentos(allDocuments)
    }

    function handlePesquisa(e) {
        setPesquisa(e.target.value)
    }

    function handleLimparFiltros() {
        setPesquisa("")
        handlePosicao(null)
    }

    function handlePosicao(e) {
        console.log("Documentos.handlePosicao: ", e?.target?.value)
        setPosicao(e?.target?.value)
    }

    return (
        <div style={{ height: "80vh", overflowY: "auto" }}>
            {modal &&
                <UploadDocumentos onCloseEv={closeModal}
                    tipos={tipos.filter(e => (props.empresa ? _tiposEmpresa : _tiposFuncionario).indexOf(e.TIPO) >= 0)}
                    pessoaid={pessoaid}
                    empresa={props.empresa}
                    data={editar} />
            }
            <div
                style={{
                    flexDirection: width() == "mobile" ? "column" : "",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                }}
            >
                <div className="col-md-12 mb-5">
                    <div className={`${width() == "mobile" ? "h3" : "h1"} center-elements`}>Documentos {props.empresa ? "da Empresa" : "dos Funcionários"}</div>
                </div>

                <div className="col-md-12 mb-2">
                    <div className={`${width() == "mobile" ? "col-12" : "col-3 p-0"} d-flex align-items-center justify-content-left mb-3`}>
                        <button className="btn btn-secondary"
                            onClick={e => {
                                if (props.onCloseEv)
                                    props?.onCloseEv()
                            }}

                        >
                            <i className="fa fa-window-close"></i>
                        </button>
                        <button className="btn btn-primary ml-1" onClick={() => {
                            setModal({ insert: true });
                        }} disabled={carregando}>
                            <i className="fa fa-plus-circle"></i>
                        </button>
                    </div>
                    <div className={`p-0 ${width() == "mobile" ? "d-block" : "d-flex"} `}>
                        <div className={`${width() == "mobile" ? " col-12" : "col-3 p-0"} `}>
                            <InputLabelAlert
                                type="text"
                                label="Pesquisa"
                                id="pesquisa"
                                cifrao={false}
                                value={pesquisa}
                                handle={handlePesquisa}
                                focus={true}
                            />
                        </div>
                        <div className={`${width() == "mobile" ? " col-12" : "col-2 ml-2 p-0"} `}>
                            <label className="m-0 font-90">Posição</label>
                            <select className="form-control" onChange={handlePosicao} >
                                <>
                                    <option value="" selected={!posicao}>Todos...</option>
                                    {posicoes?.map((item, key) => {
                                        return (
                                            <option key={key} value={item.posicao} selected={posicao == item.posicao}>{item.descricao}</option>
                                        )
                                    })}
                                </>
                            </select>
                        </div>
                        <div className={`${width() == "mobile" ? " col-12 mb-2" : "col-2 ml-2 p-0"} `}>
                            <div className="mt-3">
                                <button className={`${width() == "mobile" ? "" : "ml-1 "} btn btn-secondary `} onClick={handleLimparFiltros} >
                                    Limpar Filtros
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12" style={{ overflowX: "auto", }}>
                    {/* <div className="border rounded p-1 mb-1"> */}
                    <div>
                        <table className="table table-striped table-hover mb-1 rounded " >
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col" style={{ width: "5%" }}>#</th>
                                    {!props.empresa && <th scope="col" style={{ width: "50%" }}>Pessoa</th>}
                                    <th scope="col" >Tipo</th>
                                    <th scope="col" style={{ width: "10%" }}>Validade</th>
                                    {/* <th scope="col"></th> */}
                                    <th
                                        scope="col"
                                        style={{ width: "10%" }}
                                        className="text-center"
                                    >
                                        Ações
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {!Documentos && <tr>Carregando...</tr>}
                                {
                                    Documentos?.map((doc, index) => {
                                        if (agrupamento != doc.PESSOA) {
                                            agrupamento = doc.PESSOA
                                            grupo = true
                                            console.log("grupo: ", grupo)
                                        }
                                        else
                                            grupo = false
                                        return (<>
                                            {index >= actualPage * qtdLinesPage &&
                                                index < (actualPage + 1) * qtdLinesPage &&
                                                (

                                                    <tr style={{
                                                        cursor: "pointer", textDecoration: ["VENCIDO", "INATIVO", "VENCENDO"].indexOf(doc.POSICAO) >= 0 ? "line-through" : "",
                                                        textDecorationStyle: ["VENCIDO", "INATIVO"].indexOf(doc.POSICAO) >= 0 ? "double" : "",
                                                        color: ["VENCIDO", "INATIVO"].indexOf(doc.POSICAO) >= 0 ? "red " : doc.POSICAO == "VENCENDO" ? "orange" : ""
                                                    }}
                                                        onDoubleClick={() => handleEdit(doc)} >
                                                        <th scope="row" style={{ maxWidth: "10px", width: "5%" }}>{index + 1}</th>
                                                        {!props.empresa && <td style={{ maxWidth: "150px", width: "50%" }}>{doc.PESSOA}</td>}
                                                        <td >{doc.TIPO_DOCUMENTO || doc.CATEGORIA}</td>
                                                        <td style={{ width: "10%" }}>{moment(doc.VALIDADE).format('DD/MM/YYYY')}</td>
                                                        <td style={{ width: "10%" }}>
                                                            <div className="d-flex justify-content-center" style={{ overflow: 'hidden', }}>
                                                                <DropDownMenu items={[
                                                                    { descricao: "Editar", onClick: e => handleEdit(doc), className: "fa fa-edit", title: "Editar o Documento" },
                                                                    { descricao: "Excluir", onClick: e => handleDelete(doc), className: "fa fa-trash", title: "Excluir o Documento", color: "red" },
                                                                    { descricao: "Download", url: doc.URL_ARQUIVO, className: "fa fa-download", title: "Fazer Download do Documento" },
                                                                    { descricao: "Copiar Link", onClick: e => handleCopiar(doc.URL_ARQUIVO), className: "fa fa-copy", title: "Copiar link do Documento", separatorTop: true },
                                                                ]} />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                        </>
                                        )
                                    })
                                }
                            </tbody>
                            {/* <tfoot> */}
                            <tr>
                                <td colSpan="12" className="text-left">
                                    Total de Registros: {Documentos && Documentos.length}
                                </td>
                            </tr>
                            {/* </tfoot> */}
                        </table>
                    </div>
                    <Pagination
                        detailed={Documentos}
                        actual={actualPage}
                        changePage={handlePage}
                        setQtdLinesPage={setQtdLinesPage}
                    />
                </div>
            </div>

            {excluindo && <Aguarde />}
        </div>
    );
}

export default Documentos;

